'use strict';
window.EROpenPrescription=async ({product,variant,host,onClose,onAdded,measurementEntry}) => {
  const handle=product.handle;
  await Promise.all(['original-rx-form.css','rx-lens-colours.css','rx-form-theme.css'].map(name=>new Promise((resolve,reject)=>{
    const id='er-rx-style-'+name;
    if(document.getElementById(id)){resolve();return;}
    const link=document.createElement('link');link.id=id;link.rel='stylesheet';link.href=window.ERTheme.rxStyles?.[name]||window.ERTheme.assetRoot+'er-ui-'+name;
    link.onload=resolve;link.onerror=()=>{link.remove();reject(new Error('Unable to load lens configuration styles.'));};document.head.append(link);
  })));
  const response=await fetch(window.ERTheme.formPayload||window.ERTheme.assetRoot+'er-ui-form-'+handle+'.json');
  if (!response.ok) throw new Error('The prescription form could not be loaded.');
  const template=(await response.text()).replaceAll('__ER_ASSET_ROOT__',window.ERTheme.assetRoot);
  const form=document.createElement('form');form.className='er-native-rx-form';form.noValidate=true;host.append(form);
  form.innerHTML='<input type="hidden" name="id"><input type="hidden" name="product-id"><button id="rx-preview-entry" type="button" data-rx-test-bag>Select Lenses &amp; Buy</button>'+JSON.parse(template);
  form.elements.id.value=variant.id;form.elements['product-id'].value=product.id;
  form.addEventListener('submit',event=>event.preventDefault());
  const root=form.querySelector('[data-rx-test]');
  root.erMeasurementEntry=measurementEntry;
  root.dataset.basePrice=variant.price;root.dataset.currency=window.ERTheme.currency;
  root.dataset.rxPreviewOnly='false';root.dataset.rxRoute='direct';
  root.querySelector('[data-rx-variants]').textContent=JSON.stringify(product.variants.map(v=>({id:v.id,title:v.frame_title||v.title,price:v.price,image:v.image})));
  root.querySelectorAll('img').forEach(image=>{image.src=variant.image;image.alt=product.title;});
  root.querySelectorAll('.rx-eyebrow').forEach(el=>{if(el.textContent.includes(product.model))el.textContent=el.textContent.replace(product.model,'').replace(/^\s*·\s*/,'').trim();});
  root.querySelectorAll('.rx-review-product strong').forEach(el=>el.textContent=product.title);
  root.querySelector('[data-rx-review-prices]')?.insertAdjacentHTML('afterend','<p class="rx-test-note production-time">Made to order · Approx. 7 calendar days before shipping. Shipping time is additional.</p>');
  const packages=window.ERLensPackagesFor(product);
  const connection=root.querySelector('[data-rx-connection]');
  const settings=JSON.parse(connection.textContent);
  Object.assign(settings,{enabled:true,route:'direct',demo_only:false,packages,lenses:window.ERTheme.lenses,catalog:window.ER_SHOPIFY_LENS_CATALOG,frameVariants:product.variants});
  connection.textContent=JSON.stringify(settings);
  const colours=window.ERLensColours.mount(root,packages);
  host.erDispose=()=>colours.destroy();
  const Native=window.ERNativeRxCartBase || window.EmberRxNativeCart;
  window.ERNativeRxCartBase=Native;
  let completed=false;
  window.EmberRxNativeCart=class extends Native {
    async submit(payload,file) {
      const colour=colours.selection();
      if (!colour) throw new Error('Choose a lens colour to continue.');
      // Choices are committed while the native uploader owns the busy state.
      // Stop observing that state and detach only after Shopify confirms both lines.
      colours.suspend();
      try {
        const result=await super.submit({...payload,config:{...payload.config,erColourId:colour.id}},file);
        window.ERPurchaseNavigation?.navigateCart(null,'rx_review');
        await measurementEntry?.tracker.flush();
        completed=true;onAdded();return result;
      } catch(error) {colours.resume();throw error;}
    }
  };
  root.querySelectorAll('dialog').forEach(dialog=>dialog.addEventListener('close',()=>{
    if (!completed && !root.querySelector('dialog[open]')) onClose();
  }));
  const script=document.createElement('script');script.src=window.ERTheme.rxRuntime||window.ERTheme.assetRoot+'er-ui-original-rx-form.js';
  script.onload=()=>form.querySelector('#rx-preview-entry').click();
  script.onerror=()=>{if(measurementEntry)window.ERNativeMeasurement.openFailed(measurementEntry);onClose();};document.body.append(script);
};
